const PlayerCard = ({player, handleVoteByPlayer})=>{

    return(
                    <div className='player-list-item-container-nominate' 
                        onClick={()=> handleVoteByPlayer(player)}
                        >
                            <img className='player-list-backgroun-placeholder' src='https://assets.talachaapp.com/Captura_de_pantalla_2026-03-11_a_la_s__18.00.57-removebg-preview.png' />
                            <img className='player-list-img' src={player?.img} />
                            <div className='player-lits-blur' />
                            <p className='player-lits-name'>{player?.name}</p>
                            <p className='player-list-buttoon-vote' >Votar</p>

                     </div>
    )
}

export default PlayerCard